import { observer } from 'mobx-react-lite';
import { useMemo, useEffect } from 'react';
import Popup from '../../../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../../../hooks/useStore';
import { Form, Formik, useFormikContext } from 'formik';
import CommonButton from '../../../../../../components/common-components/button/CommonButton';
import { FormikTextField } from '../../../../../../components/form-components/common-components/text-field/FormikTextField';
import { FormikDropdown } from '../../../../../../components/form-components/common-components/dropdown/FormikDropdown';
import { toast } from 'react-toastify';
import styles from './NewTagNumber.module.css';
import {
  IHospitalResult,
  NewTagNumberFormValues,
  newTagNumberInitialValues,
} from '../../../../../../models/hospital/HospitalModel';
import { NewTagNumberSchema } from '../../../../../../schemas/NewTagNumberSchema';
import { RsValue } from '../../../../../../models/base/BaseModel';

const PopupFooter = ({ onClose }: { onClose: () => void }) => {
  const { isSubmitting, submitForm } = useFormikContext<NewTagNumberFormValues>();
  const { uiStore } = useStore();

  return (
    <>
      <CommonButton type="cancel" onClick={onClose} disabled={isSubmitting}>
        İptal
      </CommonButton>
      <CommonButton
        type="save"
        onClick={submitForm}
        disabled={isSubmitting}
        loading={uiStore.isLoading}
      >
        Kaydet
      </CommonButton>
    </>
  );
};

const NewTagNumber = () => {
  const { popupStore, hospitalStore, hospitalFilesStore, uiStore } = useStore();

  useEffect(() => {
    hospitalStore.listAllHospitals();
  }, [hospitalStore]);

  const hospitalOptions: { value: number; label: string }[] = useMemo(
    () =>
      hospitalStore.hospitalList
        .filter(
          (hospital): hospital is IHospitalResult & { id: number; hospitalName: string } =>
            hospital.id !== undefined && hospital.hospitalName !== undefined
        )
        .map(hospital => ({
          value: hospital.id,
          label: hospital.hospitalName,
        })),
    [hospitalStore.hospitalList]
  );

  const handleSubmit = async (values: NewTagNumberFormValues) => {
    try {
      if (!values.hospitalId) {
        toast.error('Lütfen bir hastane seçiniz');
        return;
      }

      uiStore.setLoading(true);
      const response: RsValue<any> = await hospitalFilesStore.addHospitalTagPrefix({
        hospitalId: values.hospitalId,
        prefix: values.prefix,
      });
      if (!response.error) {
        toast.success('Ön ek başarıyla eklendi');
        popupStore.setIsNewTagOpen(false);
      } else {
        toast.error('Ön ek eklenirken bir hata oluştu : ' + response.message);
      }
    } catch (error) {
      console.error('Prefix eklenirken hata:', error);
      toast.error('Ön ek eklenirken bir hata oluştu');
    } finally {
      uiStore.setLoading(false);
    }
  };
  const handleClose = () => {
    popupStore.setIsNewTagOpen(false);
    toast.dismiss();
  };
  return (
    <Formik
      initialValues={newTagNumberInitialValues}
      validationSchema={NewTagNumberSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <Popup
          isOpen={popupStore.isNewTagOpen}
          onClose={handleClose}
          title="Hastane Etiket No Ekle"
          footer={() => <PopupFooter onClose={handleClose} />}
        >
          <div className={styles.container}>
            <Form className={styles.form}>
              <div className={styles.inputContainer}>
                <FormikDropdown
                  name="hospitalId"
                  options={hospitalOptions}
                  label="Hastane Seçiniz"
                />
              </div>
              <div className={styles.inputContainer}>
                <FormikTextField name="prefix" label="Ön Ek" placeholder="Ön ek giriniz" />
              </div>
            </Form>
          </div>
        </Popup>
      )}
    </Formik>
  );
};

export default observer(NewTagNumber);
